// extracted by mini-css-extract-plugin
export default {"tabs":"G8-z","tablist":"H8-z","tablistItem":"I8-z"};